const action = {
    sign_in: 'Přihlásit se',
    continue: 'Pokračovat',
    continue_as: 'Pokračovat jako {{name}}',
    create_account: 'Vytvořit účet',
    create_account_without_linking: 'Místo toho vytvořit nový',
    create: 'Vytvořit',
    enter_passcode: 'Zadej ověřovací kód',
    confirm: 'Potvrdit',
    cancel: 'Zrušit',
    save_password: 'Uložit heslo',
    bind: 'Propojit s {{address}}',
    bind_and_continue: 'Propojit a pokračovat',
    back: 'Jít zpět',
    nav_back: 'Zpět',
    nav_skip: 'Přeskočit',
    agree: 'Souhlasím',
    got_it: 'Rozumím',
    sign_in_with: 'Pokračovat s {{name}}',
    forgot_password: 'Zapomněl/a jsi heslo?',
    switch_to: 'Přepnout na {{method}}',
    sign_in_via_passcode: 'Přihlásit se ověřovacím kódem',
    sign_in_via_password: 'Přihlásit se heslem',
    sign_in_via_passkey: 'Přihlásit se přístupovým klíčem',
    change: 'Změnit {{method}}',
    link_another_email: 'Propojit jiný e-mail',
    link_another_phone: 'Propojit jiné telefonní číslo',
    link_another_email_or_phone: 'Propojit jiný e-mail nebo telefonní číslo',
    show_password: 'Zobrazit heslo',
    copy: 'Kopírovat',
    verify_via_passkey: 'Ověřit přes přístupový klíč',
    reset_password_via_passkey: 'Obnovit heslo pomocí přístupového klíče',
    download: 'Stáhnout',
    remove: 'Odstranit',
    edit: 'Upravit',
    save: 'Uložit',
    single_sign_on: 'Single Sign-On',
    authorize: 'Povolit',
    use_another_account: 'Použít jiný účet',
    back_to_current_account: 'Zpět k aktuálnímu účtu',
    done: 'Hotovo',
};
export default Object.freeze(action);
